"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var context_1 = require("./context");
var helpers_1 = require("../helpers");
var StackView_1 = require("../StackView");
var Text_1 = require("../Text");
var LinkButton_1 = require("../controls/LinkButton");
var View_1 = require("../View");
var Spacer_1 = require("../layouts/Spacer");
var Tooltip_1 = require("../Tooltip");
var helpers_2 = require("../Grid/cellRenderers/helpers");
var config = {
    title: {
        marginTop: helpers_1.SPACING_M,
        lineHeight: '20px',
        marginBottom: helpers_1.SPACING_S
    },
    headerAddon: {
        maxHeight: helpers_1.SIZE_XL
    },
    footer: {
        height: helpers_1.SPACING_XL,
        marginBottom: helpers_1.SPACING_S
    }
};
var Title = styled_components_1.default(Text_1.Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: ", ";\n    line-height: ", ";\n"], ["\n    min-width: ", ";\n    line-height: ", ";\n"])), helpers_1.SPACING_M, config.title.lineHeight);
var TitleWithTooltip = function (_a) {
    var text = _a.text, rest = __rest(_a, ["text"]);
    var ref = react_1.useRef(null);
    return Tooltip_1.useTooltip({
        renderContent: function () { return react_1.default.createElement(helpers_2.TooltipText, { size: Text_1.TEXT_SIZE.s }, text); },
        render: function (tooltipProps) {
            return (react_1.default.createElement(Title, __assign({}, rest, { size: Text_1.TEXT_SIZE.l, weight: Text_1.TEXT_WEIGHT.bold, truncate: true, onMouseEnter: function () {
                    helpers_2.onMouseEnterHandlerDecorator(tooltipProps.onMouseEnter, ref)();
                }, onMouseLeave: function () {
                    tooltipProps.onMouseLeave();
                }, ref: ref }), text));
        }
    });
};
var HeaderAddonWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    max-height: ", ";\n"], ["\n    display: flex;\n    max-height: ", ";\n"])), config.headerAddon.maxHeight);
var Header = styled_components_1.default(StackView_1.StackView)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n"], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n"])), helpers_1.SPACING_M, helpers_1.SPACING_S);
var Body = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    overflow: auto;\n    margin-top: ", ";\n"], ["\n    overflow: auto;\n    margin-top: ", ";\n"])), helpers_1.SPACING_S);
var HeaderBodyWrapper = styled_components_1.default(StackView_1.StackView)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n"], ["\n    ",
    "\n"])), function (_a) {
    var hasViewMore = _a.hasViewMore;
    if (hasViewMore) {
        return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                height: calc(100% - ", " - ", ");\n            "], ["\n                height: calc(100% - ", " - ", ");\n            "])), config.footer.height, config.footer.marginBottom);
    }
    return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            height: 100%;\n        "], ["\n            height: 100%;\n        "])));
});
var Footer = styled_components_1.default(StackView_1.StackView)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    height: ", ";\n    margin-bottom: ", ";\n"], ["\n    height: ", ";\n    margin-bottom: ", ";\n"])), config.footer.height, config.footer.marginBottom);
var Root = styled_components_1.default(StackView_1.StackView)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: inline-flex;\n    box-sizing: border-box;\n    width: 560px;\n    height: 368px;\n\n    background-color: #fff;\n    box-shadow: 0 3px 6px #00000029;\n"], ["\n    display: inline-flex;\n    box-sizing: border-box;\n    width: 560px;\n    height: 368px;\n\n    background-color: #fff;\n    box-shadow: 0 3px 6px #00000029;\n"])));
exports.DashboardPlate = helpers_1.createUIElement('DashboardPlate', function (_a, ref) {
    var className = _a.className, title = _a.title, headerAddon = _a.headerAddon, content = _a.content, _b = _a.hasViewMore, hasViewMore = _b === void 0 ? false : _b, viewMoreIcon = _a.viewMoreIcon, onShowMoreClick = _a.onShowMoreClick, texts = _a.texts, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "title", "headerAddon", "content", "hasViewMore", "viewMoreIcon", "onShowMoreClick", "texts", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var dashboardPlateContext = react_1.useContext(context_1.DashboardPlateContext);
    var uiTexts = __assign({ viewMore: dashboardPlateContext.viewMoreText }, texts);
    return (react_1.default.createElement(Root, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'dashboard-plate', className: "vm-DashboardPlate " + className, direction: StackView_1.STACK_DIRECTION.column, distribution: StackView_1.STACK_DISTRIBUTION.firstFill, spaceHorizontal: View_1.INDENT.m, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(HeaderBodyWrapper, { hasViewMore: hasViewMore, direction: StackView_1.STACK_DIRECTION.column, distribution: StackView_1.STACK_DISTRIBUTION.lastFill },
            react_1.default.createElement(Header, { indentLeft: View_1.INDENT.s, gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.center, size: { height: config.title.lineHeight } },
                react_1.default.createElement(TitleWithTooltip, { text: title }),
                headerAddon && react_1.default.createElement(HeaderAddonWrapper, null, headerAddon)),
            react_1.default.createElement(Body, null, content)),
        hasViewMore && (react_1.default.createElement(Footer, null,
            react_1.default.createElement(Spacer_1.Spacer, null),
            react_1.default.createElement(LinkButton_1.LinkButton, { iconBefore: viewMoreIcon ||
                    dashboardPlateContext.viewMoreIcon ||
                    context_1.initialContextValue.viewMoreIcon, onClick: onShowMoreClick }, uiTexts.viewMore || context_1.initialContextValue.viewMoreText)))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=DashboardPlate.js.map